import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {ConfService} from '../conf.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {split} from 'ts-node';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {environment} from '../../environments/environment';
import {downloadFile} from 'export-from-json/dist/types/processors';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {DialogData} from '../settings/settings.component';
import {FilemangerListenerService} from '../filemanger-listener.service';
import {AccountInfoService} from '../user/account-info.service';

declare let $;

export interface FolderFileResponseModel {
    Folder: String;
    Filename: String;
    Progress: number;
}

export interface FileResponseModel {
    file: File;
    progres: number;
    filename: string;
}

export interface DirectoryData {
    partner: string;
    directory: string;
}

@Component({
    selector: 'app-file-store',
    templateUrl: './file-store.component.html',
    styleUrls: ['./file-store.component.css']
})
export class FileStoreComponent implements OnInit {
    items: any;
    searchText: any;
    settings: any;
    filterData: any;
    itemList: any[];
    @Input() partner = localStorage.getItem('partner');
    entity = 'File Storage';
    itemLength: any;
    directory = '';
    files = [];
    folders = [];
    pathArr = [];
    currentpath: any;
    currentItems = <any> [];
    pathArrLength: any;
    folderName: String;
    folderUploadedArray = [];
    s = 0;
    @Input() fromWorkflow = false;
    @Output() importBpmnFile: EventEmitter<any> = new EventEmitter<any>();

    constructor(private confPost: ConfService,
                private router: Router,
                private fileManagerListenerInstance: FilemangerListenerService,
                public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                public dialog: MatDialog,
                private _snackBar: MatSnackBar) {
    }

    ngOnInit() {
        this.populateTable();
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
    }

    populateTable() {
        this.items = null;
        this.folders = [];
        this.files = [];
        this.pathArr = [];
        this.directory = '';
        this.confPost.getS3Files(this.partner).subscribe((data) => {
            this.items = data;
            this.itemLength = this.items.length;
            for (let i = 0; i < this.items.length; i++) {
                const splited = this.items[i]['filePath'].split('/');
                const size = this.formatBytes(this.items[i]['Content-Length'], 2);
                this.s += this.items[i]['Content-Length'];

                if (!this.folders.includes(splited[0]) && splited[0] !== '') {
                    this.s = 0;
                    const obj = {
                        length: splited.length,
                        path: splited[0],
                        size: this.getFileSize(splited, this.items, i),
                        downloadUri: 'https://' + this.partner + '.apiplatform.io.s3.amazonaws.com/' + this.directory + splited[0],
                        dateModified: this.items[i]['Last-Modified']
                    };

                    this.folders.push(splited[0]);
                    this.files.push(obj);
                }
            }

        }, error => {
            this.platform.handleErrorGracefully(error, 'Oops!!! Error. Please try again after sometime.');
        });
    }

    populateTable1() {
        this.items = null;
        this.folders = [];
        this.files = [];
        //this.pathArr = [];
        //this.directory = '';
        this.currentItems = [];

        this.confPost.getS3Files(this.partner).subscribe((data) => {
            this.items = data;
            this.itemLength = this.items.length;
            for (let i = 0; i < this.items.length; i++) {
                const splited = this.items[i]['filePath'].split('/');
                const size = this.formatBytes(this.items[i]['Content-Length'], 2);
                this.s += this.items[i]['Content-Length'];

                if (!this.folders.includes(splited[0]) && splited[0] !== '') {
                    this.s = 0;
                    const obj = {
                        length: splited.length,
                        path: splited[0],
                        size: this.getFileSize(splited, this.items, i),
                        downloadUri: 'https://' + this.partner + '.apiplatform.io.s3.amazonaws.com/' + this.directory + splited[0],
                        dateModified: this.items[i]['Last-Modified']
                    };
                    this.folders.push(splited[0]);
                    this.files.push(obj);
                }
            }
            this.items.forEach(item => {
                this.files.forEach(file => {
                    if (item.filePath !== file.path) {
                        if (this.currentItems && !this.currentItems.includes(item)) {
                            this.currentItems.push(item);
                        }
                    }
                });
            });
            this.getFiles(this.currentpath, this.currentItems);

        }, error => {
            this.platform.handleErrorGracefully(error, 'Oops!!! Error. Please try again after sometime.');
        });
    }

    addFileSize(arrOfFileSize) {
        let size = 0;
        for (const file of arrOfFileSize) {
            size += file['Content-Length'];
        }
        return size;
    }

    getFileSize(fileArr, fileObjs, fileIndex) {
        const tempSizeArr = fileObjs.filter(value => value['filePath'].startsWith(fileArr[0]));
        let size: any;
        if (fileArr.length > 1) {
            size = this.formatBytes(this.addFileSize(tempSizeArr), 2);
        } else {
            size = this.formatBytes(fileObjs[fileIndex]['Content-Length'], 2);
        }
        return size;
    }


    backTraceDirectory(val, itemsParam) {
        const items = JSON.parse(JSON.stringify(itemsParam));
        const index = this.directory.indexOf(this.pathArr[val]);
        this.directory = this.directory.slice(0, index + this.pathArr[val].length + 1);
        if (val < this.pathArr.length) {
            this.pathArr.splice(val + 1, this.pathArr.length);
        }
        this.currentpath = this.pathArr[this.pathArr.length - 1];
        const temp = items.filter(item => item['filePath'].startsWith(this.directory));

        this.folders = [];
        this.files = [];


        for (let i = 0; i < temp.length; i++) {
            temp[i]['filePath'] = temp[i]['filePath'].replace(this.directory, '');
        }
        this.itemLength = temp.length;
        for (let i = 0; i < this.itemLength; i++) {


            let splited = temp[i]['filePath'].split('/');
            //splited = splited.splice(0, 1);
            if (!this.folders.includes(splited[0]) && splited[0] !== '') {
                const obj = {
                    length: splited.length,
                    path: splited[0],
                    size: this.getFileSize(splited, temp, i),
                    downloadUri: 'https://' + this.partner + '.apiplatform.io.s3.amazonaws.com/' + this.directory + splited[0],
                    dateModified: items[i]['Last-Modified']
                };

                this.folders.push(splited[0]);
                this.files.push(obj);
            }


        }
    }

    getFiles(val, itemsParam) {
        const items = JSON.parse(JSON.stringify(itemsParam));
        this.folders = [];
        this.files = [];
        this.searchText = '';

        if (val === -1) {
            this.pathArr = [];
            this.directory = '';
            for (let i = 0; i < items.length; i++) {
                const splited = this.items[i]['filePath'].split('/');
                const size = this.formatBytes(this.items[i]['Content-Length'], 2);
                this.s += this.items[i]['Content-Length'];

                if (!this.folders.includes(splited[0]) && splited[0] !== '') {
                    this.s = 0;
                    const obj = {
                        length: splited.length,
                        path: splited[0],
                        size: this.getFileSize(splited, this.items, i),
                        downloadUri: 'https://' + this.partner + '.apiplatform.io.s3.amazonaws.com/' + this.directory + splited[0],
                        dateModified: this.items[i]['Last-Modified']
                    };

                    this.folders.push(splited[0]);
                    this.files.push(obj);
                }
            }
            return;
        }

        if (this.pathArr && this.pathArr[this.pathArr.length - 1] !== val || !this.pathArr) {
            this.pathArr.push(val);
            this.directory = this.directory + val + '/';
        }

        this.pathArrLength = this.pathArr.length;
        //this.directory = this.directory + val + '/';
        let temp = items.filter(item => item['filePath'].startsWith(this.directory));
        this.itemLength = temp.length;

        for (let i = 0; i < temp.length; i++) {
            temp[i]['filePath'] = temp[i]['filePath'].replace(this.directory, '');
        }
        for (let i = 0; i < temp.length; i++) {
            //const a = temp[i]['filePath'].replace(this.directory, '');

            let splited = temp[i]['filePath'].split('/');
            if (!this.folders.includes(splited[0]) && splited[0] !== '') {
                const obj = {
                    length: splited.length,
                    path: splited[0],
                    size: this.getFileSize(splited, temp, i),
                    dateModified: items[i]['Last-Modified'],
                    downloadUri: 'https://' + this.partner + '.apiplatform.io.s3.amazonaws.com/' + this.directory + splited[0]
                };
                this.folders.push(splited[0]);
                this.files.push(obj);
            }
        }
        this.currentpath = val;
    }

    formatBytes(bytes, decimalPoint) {
        if (bytes === 0) {
            return '0 B';
        }
        const k = 1000,
            dm = decimalPoint || 2,
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    deleteFile(val, event) {
        if (confirm('This action is irreversible, Are you sure you want to delete this file?')) {
            if (this.files[val].length === 1) {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_deletefile_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.fileManagerListenerInstance.fileManagerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.confPost.deleteFileFromS3Bucket(this.partner, this.directory + this.files[val].path).subscribe(data => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_deletefile_success', 'INFO', data.status, data.statusText, '', {file: this.directory + this.files[val].path}, data, this.router.url)).then(response => {
                            const payloadToSend = {
                                actions: response
                            };
                            this.fileManagerListenerInstance.fileManagerListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        this.platform.openSnackBar('Deleted successfully', 'Success', {
                            duration: 2000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.deleteFromUI(event);
                        this.populateTable1();
                    },
                    error => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'filemanager_deletefile_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {file: this.directory + this.files[val].path}, error, this.router.url)).then(response => {
                            const payloadToSend = {
                                actions: response
                            };
                            this.fileManagerListenerInstance.fileManagerListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        this.platform.openSnackBar('Error while deleting file: ' + error.error.message, 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
            } else {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_deletefolder_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.fileManagerListenerInstance.fileManagerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.confPost.deleteFolderFromS3Bucket(this.partner, this.directory + this.files[val].path).subscribe(data => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_deletefolder_success', 'INFO', data.status, data.statusText, '', {folder: this.directory + this.files[val].path}, data, this.router.url)).then(response => {
                            const payloadToSend = {
                                actions: response
                            };
                            this.fileManagerListenerInstance.fileManagerListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        this.platform.openSnackBar('Deleted successfully', 'Success', {
                            duration: 2000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.deleteFromUI(event);
                        this.populateTable1();
                    },
                    error => {
                        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'filemanager_deletefolder_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {folder: this.directory + this.files[val].path}, error, this.router.url)).then(response => {
                            const payloadToSend = {
                                actions: response
                            };
                            this.fileManagerListenerInstance.fileManagerListener.emit({
                                type: 'audit',
                                id: localStorage.getItem('IdOfSession'),
                                payload: payloadToSend
                            });
                        });
                        this.platform.openSnackBar('Error while deleting folder: ' + error.error.message, 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
            }

        }

    }

    deleteFromUI(event) {
        $(event.target).closest('td').parent('tr').remove();
    }

    openCreateFolderDialog() {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_createfolder_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.fileManagerListenerInstance.fileManagerListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        const dialogVar = this.dialog.open(CreateFolderDialog, {
            width: '400px',
        });
        dialogVar.afterClosed().subscribe(name => {
            if (typeof name !== 'undefined' && name !== '' && name !== 'cancel') {
                this.confPost.createFolderInS3(this.partner, this.directory + name).subscribe((resp) => {
                    let data: any;
                    data = resp;
                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_createfolder_success', 'INFO', data.status, data.statusText, '', {folderName: this.directory + name}, data, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.fileManagerListenerInstance.fileManagerListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.populateTable1();
                    this.platform.openSnackBar('Folder Created', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }, error => {
                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'filemanager_createfolder_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {folderName: this.directory + name}, error, this.router.url)).then(response => {
                        const payloadToSend = {
                            actions: response
                        };
                        this.fileManagerListenerInstance.fileManagerListener.emit({
                            type: 'audit',
                            id: localStorage.getItem('IdOfSession'),
                            payload: payloadToSend
                        });
                    });
                    this.platform.handleErrorGracefully(error, 'Oops!!! Error. Please try again after sometime.');

                });

            } else if (name !== 'cancel') {
                this.platform.openSnackBar('Invalid File Name', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        });
    }


    openUploadFileDialog() {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_uploadfile_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.fileManagerListenerInstance.fileManagerListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const dialogVar = this.dialog.open(UploadFileDialog, {
            height: '75%',
            width: '75%',
            data: {partner: this.partner, directory: this.directory}
        });
        dialogVar.afterClosed().subscribe(name => {
            // if (name !== undefined && name !== '') {
            //     this.populateTable();
            // }
            this.populateTable1();
        });
    }

    openUploadFolderDialog() {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_uploadfolder_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.fileManagerListenerInstance.fileManagerListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const dialogVar = this.dialog.open(UploadFolderDialog, {
            height: '75%',
            width: '75%',
            data: {partner: this.partner, directory: this.directory}
        });
        dialogVar.afterClosed().subscribe(name => {

            // if (name !== undefined && name !== '') {
            //     this.populateTable();
            // }
            this.populateTable1();
        });
    }

    onImportingBpmnFile(file) {
        this.importBpmnFile.emit(file);
    }

    createMarginRight() {
        document.getElementById('view:file_storage').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:file_storage').style.marginRight = '0px';
    }
}

@Component({
    templateUrl: './Create_Folder_dialog.html',
})
export class CreateFolderDialog {
    folderName: String;

    constructor(public dialogRef: MatDialogRef<CreateFolderDialog>) {
    }

    closeDialog() {
        this.dialogRef.close('cancel');
    }
}

@Component({
    templateUrl: './addFileComponent.html',
})
export class UploadFileDialog {
    files: any[] = [];
    color: ThemePalette = 'primary';
    mode: ProgressSpinnerMode = 'determinate';
    isDisabled = true;
    response: FileResponseModel[] = [];
    dialogResult: any;

    constructor(private confPost: ConfService, public dialogRef: MatDialogRef<UploadFileDialog>, public router: Router, public fileManagerListenerInstance: FilemangerListenerService,
                @Inject(MAT_DIALOG_DATA) public data: DirectoryData, public dialog: MatDialog, public platform: LeftpanelComponent, private _snackBar: MatSnackBar) {
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
    }

    onFileDropped($event) {


        this.prepareFilesList($event);
    }

    fileBrowseHandler(files) {

        this.prepareFilesList(files);
    }

    deleteFile(index: number) {
        if (confirm('Are you sure you want to remove this file?')) {
            if (this.files[index].progress < 100) {
                this.platform.openSnackBar('File Upload in Progress', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                return;
            }
            this.files.splice(index, 1);
            this.isDisabled = true;
        }
    }


    uploadFilesSimulator(index: number) {
        setTimeout(() => {
            if (index === this.files.length) {
                this.isDisabled = false;
                return;
            } else {
                const progressInterval = setInterval(() => {
                    if (this.files[index].progress === 100) {
                        clearInterval(progressInterval);
                        this.uploadFilesSimulator(index + 1);
                    } else {
                        this.files[index].progress += 5;
                    }
                }, 200);
            }
        }, 1000);
    }

    processFile() {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.isDisabled = true;
        const responseArr = [];
        const temp = this.data.directory.slice(0, -1);
        for (let i = 0; i < this.files.length; i++) {

            const fileObject = {
                'lastModified': this.files[i].lastModified,
                'lastModifiedDate': this.files[i].lastModifiedDate,
                'name': this.files[i].name,
                'size': this.files[i].size,
                'type': this.files[i].type
            };

            this.confPost.uploadFileInS3(this.data.partner, this.files[i], temp).subscribe((resp) => {
                let data: any;
                data = resp;
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_uploadfile_success', 'INFO', data.status, data.statusText, '', {
                    directory: temp,
                    file: fileObject
                }, data, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.fileManagerListenerInstance.fileManagerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });

                responseArr.push(data['body']);

                if (responseArr.length === this.files.length) {
                    this.platform.openSnackBar('File Uploaded', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.files = [];
                    loaderDialog.close();
                    this.closeDialog();
                    this.dialogResult = 'yes';
                }
            }, error => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'filemanager_uploadfile_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {
                    directory: temp,
                    file: fileObject
                }, error, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.fileManagerListenerInstance.fileManagerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.isDisabled = false;
                this.platform.handleErrorGracefully(error, 'Oops!!! Error while uploading file(s). Please try again after sometime.');
                loaderDialog.close();
                this.closeDialog();
            });
        }
    }

    prepareFilesList(files: Array<any>) {
        this.isDisabled = true;
        for (const item of files) {
            item.progress = 0;
            this.files.push(item);
        }
        this.uploadFilesSimulator(0);
    }


    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    closeDialog() {
        this.dialogRef.close(this.dialogResult);
    }

}

@Component({
    templateUrl: './UploadFolderDialog.html',
})
export class UploadFolderDialog {

    folders: any[] = [];
    displayedColumns: string[] = ['Folder', 'File'];
    columnsToDisplay: string[] = this.displayedColumns.slice();
    response: FolderFileResponseModel[] = [];
    color: ThemePalette = 'primary';
    mode: ProgressSpinnerMode = 'determinate';
    value = 0;
    uploadFolderArray = [];
    isDisabled = true;
    dialogResult: any;

    constructor(private confPost: ConfService, public dialogRef: MatDialogRef<UploadFolderDialog>, @Inject(MAT_DIALOG_DATA) public data: DirectoryData, public router: Router,
                public dialog: MatDialog, public platform: LeftpanelComponent, private _snackBar: MatSnackBar, public fileManagerListenerInstance: FilemangerListenerService
    ) {
    }

    ngOnInit() {
    }

    folderPicked(folders) {

        this.response = [];
        this.folders = [];
        this.isDisabled = true;
        for (let i = 0; i < folders.length; i++) {
            const file = folders[i];
            const path = file.webkitRelativePath.split('/');

            let filename = '';
            let folder = '';
            for (let j = 0; j < path.length; j++) {
                if (j == path.length - 1) {
                    filename += path[j];
                    folder = folder.slice(0, -1);
                } else {
                    folder += path[j] + '/';
                }
            }
            const obj = {
                Folder: folder,
                Filename: filename,
                Progress: file.progress
            };
            this.response.push(obj);
        }
        this.prepareFoldersList(folders);
    }


    uploadFolder() {
        this.isDisabled = true;
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        for (let i = 0; i < this.response.length; i++) {
            this.confPost.uploadFolderInS3(this.data.partner, this.folders[i], this.data.directory + this.response[i].Folder, this.response[i].Filename).subscribe((resp) => {
                let data: any;
                data = resp;
                this.uploadFolderArray.push('success');
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'filemanager_uploadfolder_success', 'INFO', data.status, data.statusText, '', {
                    directory: this.data.directory + this.response[i].Folder,
                    fileName: this.response[i].Filename
                }, data, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.fileManagerListenerInstance.fileManagerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                if (this.uploadFolderArray.length === this.response.length) {
                    this.uploadFolderArray = [];
                    this.response = [];
                    this.platform.openSnackBar('Folder Uploaded', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    loaderDialog.close();
                    this.dialogResult = 'yes';
                }
            }, error => {
                this.isDisabled = false;
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'filemanager_uploadfolder_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {
                    directory: this.data.directory + this.response[i].Folder,
                    fileName: this.response[i].Filename
                }, error, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.fileManagerListenerInstance.fileManagerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.handleErrorGracefully(error, 'Oops!!! Error while uploading folder. Please try again after sometime.');
                loaderDialog.close();
            });
        }

        this.closeDialog();
    }

    deleteFolder(index: number) {
        if (this.folders[index].progress < 100) {
            this.platform.openSnackBar('Folder Upload in Progress', 'Success', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            return;
        }
        this.folders.splice(index, 1);
    }


    uploadFoldersSimulator(index: number) {

        setTimeout(() => {
            if (index === this.folders.length) {
                this.isDisabled = false;
                return;
            } else {
                const progressInterval = setInterval(() => {
                    if (this.folders[index].progress === 100) {
                        clearInterval(progressInterval);
                        this.uploadFoldersSimulator(index + 1);
                    } else {
                        this.folders[index].progress += 5;
                        this.response[index].Progress = this.folders[index].progress;
                    }
                }, 200);
            }
        }, 1000);
    }


    prepareFoldersList(folders: Array<any>) {

        this.isDisabled = true;
        for (const item of folders) {
            item.progress = 0;
            this.folders.push(item);
        }
        this.uploadFoldersSimulator(0);
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    closeDialog() {
        this.dialogRef.close(this.dialogResult);
    }
}
